module.exports = __webpack_public_path__ + "img/icn_medal-money-accent.3490fc54.svg";